
import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator } from '../../common';

export const API_ENDPOINT = 'publisher/publishers';

const actions = createActions({
  PUBLISHER_PORTAL: {
    PUBLISHERS: {
      API: {
        GET: apiResourceActionCreator('publishers')
      },
      GET: undefined
    }
  }
});

export const apiActions = {
  publisherPortal: {
    publishers: {
      get: (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}`, authToken, actions.publisherPortal.publishers.api.get)
    }
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/publisher/actions.js